<!--suppress JSUnresolvedReference -->
<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     weight?: number|null
     *     center?: boolean | string,
     *     icon?: any,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { weight = 1, center = false, icon = null, children } = $props();

    const thisWeight = $derived(Math.min(Math.max(1, ValueService.toInt(weight ?? 1)), 6));
    const thisTag = $derived('h' + thisWeight);
    // Muss großgeschrieben sein, sonst rendert Svelte ein HTML-Element statt der Komponente.
    const ThisIcon = $derived(icon);

    /** @type {{ [key: number]: string }} */
    const useSizes = {
        1: 'text-2xl',
        2: 'text-lg',
    };

    const useClasses = $derived.by(() => {
        const classes = [
            thisWeight === 1 ? 'text-primary' : 'text-secondary',
            useSizes[thisWeight] ?? 'text-base',
            'font-bold',
            ValueService.toBool(center) ? 'text-center' : '',
        ];

        return classes.join(' ');
    });
</script>

<svelte:element this={thisTag} class={useClasses}>
    {#if ThisIcon}
        <ThisIcon size="1em" class="inline-block shrink-0 align-[-0.125em]" />
    {/if}
    {@render children?.()}
</svelte:element>
